import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import MobileDirectory from '../../containers/MobileDirectory';
import MobileHeader from '../../components/MobileHeader';
import dataModel from '../../models/DataModel';

import '../MobileWrapper.scss';
import './DirectoryWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';

class DirectoryWrapper extends BasePage {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
  }

  render() {
    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={this.textMap.directories}
          noBackButton={false}
        />
        {this.props.systemPopup}
        <div className="content-wrapper" id="directory-wrapper">
          <MobileDirectory
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataModel: dataModel,
    navigateUri: state.main.navigateUri,
    systemPopup: state.main.systemPopup,
  };
};
export default withRouter(connect(mapStateToProps)(DirectoryWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/DirectoryWrapper/index.js